// Interfaces TypeScript para a estrutura de produtos
export interface Produto {
  produto: string;
  variacoes: string[];
  imagem?: string;
  descricao?: string;
}

export interface Subdepartamento {
  subdepartamento: string;
  produtos: Produto[];
}

export interface Departamento {
  departamento: string;
  subdepartamentos: Subdepartamento[];
}

export interface ProdutosData {
  departamentos: Departamento[];
  observacao?: string;
}

type RawProduto = { nome: string; variacoes: string[] };
type RawSubdepartamentos = Record<string, RawProduto[]>;
type RawDepartamentos = Record<string, RawSubdepartamentos>;

const rawProdutosData: RawDepartamentos = {
  HIDROPONIA: {
    'KITS PARA SOLUÇÕES HIDROPÔNICAS': [
      { nome: 'solução hidropônica folhosas', variacoes: ['500 litros e 1.000 litros'] },
      { nome: 'solução hidropônica frutos 1', variacoes: ['500 litros e 1.000 litros'] },
      { nome: 'solução hidropônica frutos 2', variacoes: ['500 litros e 1.000 litros'] },
    ],
    SAIS: [
      { nome: 'ácido bórico', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      {
        nome: 'mono amônio fosfato - MAP',
        variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'],
      },
      { nome: 'nitrato de cálcio', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      { nome: 'sulfato de magnésio', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      { nome: 'sulfato de zinco', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
    ],
  },
  'ADUBOS / FERTILIZANTES / CORRETIVOS QUÍMICOS': {
    'PARA SOLO': [
      {
        nome: 'FTE BR12 - cmicronutrientes',
        variacoes: ['250g', '1kg', '5kg', '10kg', '20kg', '50kg'],
      },
      { nome: 'NPK granulado 10.10.10', variacoes: ['250g', '1kg', '5kg', '10kg', '20kg', '50kg'] },
      { nome: 'NPK granulado 04.14.08', variacoes: ['250g', '1kg', '5kg', '10kg', '20kg', '50kg'] },
      { nome: 'yoorim master', variacoes: ['250g', '1kg', '5kg', '10kg', '20kg', '40kg'] },
    ],
    SOLÚVEIS: [
      { nome: 'NPK solúve plantafol 10.54.10', variacoes: ['100g', '250g', '1kg'] },
      { nome: 'NPK solúve plantafol 30.10.10', variacoes: ['100g', '250g', '1kg'] },
      { nome: 'coquetel de micronutrientes', variacoes: ['30g', '100g', '250g', '1kg'] },
      { nome: 'ferro quelatado - Ferrilene', variacoes: ['30g', '100g', '250g', '1kg'] },
    ],
    'CORRETIVOS DE SOLO': [
      { nome: 'calcário dolomítico filler', variacoes: ['2kg', '5kg', '10kg', '25kg'] },
      { nome: 'gesso agrícola', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      { nome: 'super fosfato simples', variacoes: ['250g', '1kg', '5kg', '10kg', '20kg', '50kg'] },
    ],
    SAIS: [
      { nome: 'ácido bórico', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      {
        nome: 'mono amônio fosfato - MAP',
        variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'],
      },
      { nome: 'nitrato de cálcio', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      { nome: 'sulfato de magnésio', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
      { nome: 'sulfato de zinco', variacoes: ['250g', '500g', '1kg', '5kg', '10kg', '25kg'] },
    ],
    'LIBERAÇÃO LENTA': [
      { nome: 'osmocote 14.14.14 3M', variacoes: ['100g', '250g', '1kg', '5kg'] },
      { nome: 'osmocote 15.09.12 + micros 3M', variacoes: ['100g', '250g', '1kg', '5kg'] },
    ],
  },
  'ADUBOS E FERTILIZANTES ORGÂNICOS': {
    'ORIGEM ANIMAL': [
      { nome: 'esterco de gado', variacoes: ['10L', '35L'] },
      { nome: 'esterco de galinha', variacoes: ['2kg', '5kg', '10kg'] },
      { nome: 'farinha de ossos', variacoes: ['2kg', '5kg', '10kg', '25kg'] },
      { nome: 'húmus de minhoca', variacoes: ['2kg', '5kg', '10kg', '25kg', '50kg'] },
    ],
    'ORIGEM VEGETAL': [
      { nome: 'torta de mamona', variacoes: ['2kg', '5kg', '10kg', '25kg', '50kg'] },
      { nome: 'torta de neem', variacoes: ['250g', '1kg', '5kg', '20kg'] },
    ],
    'COMPOSTOS (combinados)': [
      { nome: 'adubo orgânic viagra orquídea', variacoes: ['250g', '500g', '1kg', '5kg', '10kg'] },
      { nome: 'adubo viagra rosas do deserto', variacoes: ['250g', '500g', '1kg', '5kg', '10kg'] },
      { nome: 'bokashi', variacoes: ['250g', '1kg', '5kg', '10kg'] },
    ],
  },
  SUBSTRATOS: {
    'SIMPLES (ou puros)': [
      { nome: 'musgo sphagnum desidratad rosa', variacoes: ['100g', '500g', '1kg', '2kg'] },
      { nome: 'carvão triturado', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'casca de arroz carbonizada', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'casca de pinus triturada M', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'chips de coco', variacoes: ['1L', '5L', '15L', '40L'] },
      { nome: 'fibra de coco em pó', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'perlita expandida', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'pó de carvão biochar', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'turfa de sphagnum ph 6.5', variacoes: ['1L', '5L', '15L', '50L', '300L'] },
      { nome: 'vermiculita expandida grossa', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
      { nome: 'vermiculita expand super fina', variacoes: ['1L', '5L', '15L', '50L', '100L'] },
    ],
    'COMPOSTOS (ou combinados)': [
      { nome: 'substrato carolina soil', variacoes: ['1L', '5L', '15L', '45L'] },
      { nome: 'substrato bioplant plus', variacoes: ['5L', '15L', '40L'] },
      { nome: 'substrato cactos e suculentas', variacoes: ['1L', '5L', '15L', '30L'] },
      { nome: 'substrato p/ orquídeas tipo 1', variacoes: ['1L', '5L', '15L', '30L'] },
      { nome: 'substrato plantas plante mais', variacoes: ['50L'] },
      { nome: 'substrato rosas do deserto', variacoes: ['1L', '5L', '15L', '30L'] },
      { nome: 'terra vegetal adubada', variacoes: ['1kg', '3kg', '5kg', '20kg'] },
    ],
    'ESPUMA FENÓLICA': [
      {
        nome: 'espuma fenólica 2x2x2Cm rúcula',
        variacoes: ['kit 345 células', '2.760 células', '5.175 células', '10.250 células'],
      },
      {
        nome: 'espuma fenólica 2x2x3cm alface',
        variacoes: ['kit 345 células', '1.725 células', '3.450 células', '6.900 células'],
      },
      {
        nome: 'espuma fenólica 2x2x3cm sem f',
        variacoes: ['kit 345 células', '1.380 células', '2.780 células', '5.520 células'],
      },
      {
        nome: 'espuma fenólica 2x2x3cm rúcula',
        variacoes: ['kit 216 células', '1.080 células', '2.160 células', '4.320 células'],
      },
      {
        nome: 'espuma fenólica 2x2x3cm sem f',
        variacoes: ['kit 216 células', '1.080 células', '2.160 células', '4.320 células'],
      },
    ],
    'CÉLULAS DE GERMINAÇÃO PEAT PELLET JIFFY': [
      {
        nome: 'célu germinação jiffy 25x35mm',
        variacoes: ['kit 10ud', '20ud', '50ud', '100ud', '500ud', '3.312ud'],
      },
      {
        nome: 'célu germinação jiffy 42x75mm',
        variacoes: ['kit 25ud', '50ud', '150ud', '300ud', '600ud'],
      },
    ],
  },
  'PRODUTOS PARA CULTIVOS': {
    'ETIQUETAS PARA IDENTIFICAÇÃO DE PLANTAS': [
      {
        nome: 'etiqueta identifica mudas E08',
        variacoes: ['kit 20ud', '50ud', '100ud', '500ud', '1.000ud'],
      },
      {
        nome: 'etiqueta identifica mudas E11',
        variacoes: ['kit 20ud', '50ud', '100ud', '500ud', '1.000ud'],
      },
      {
        nome: 'etiqueta identifica mudas E16',
        variacoes: ['kit 10ud', '50ud', '100ud', '500ud', '1.000ud'],
      },
    ],
    'SACOS PLÁSTICOS PARA MUDAS': [
      {
        nome: 'saco para mudas 12 x 12',
        variacoes: ['kit 50ud', '100ud', '250ud', '500ud', '1.000ud'],
      },
      {
        nome: 'saco para mudas 13 x 19',
        variacoes: ['kit 50ud', '100ud', '250ud', '500ud', '1.000ud'],
      },
      {
        nome: 'saco para mudas 16 x 25',
        variacoes: ['kit 20ud', '100ud', '250ud', '500ud', '1.000ud'],
      },
      {
        nome: 'saco para mudas 20 x 35',
        variacoes: ['kit 20ud', '100ud', '250ud', '500ud', '1.000ud'],
      },
    ],
  },
  'PRAGAS DOMÉSTICAS / DEFENSIVOS': {
    'HERBICIDAS / MATA MATO': [
      { nome: 'glifomato 10 flaconetes 3ml', variacoes: ['unidade'] },
      { nome: 'mata tiririca herbicida selet', variacoes: ['10g', '30g', '60g', '100g', '250g'] },
    ],
    FUNGICIDA: [
      { nome: 'enxofre agrícola solúvel 80%', variacoes: ['100g', '250g', '1kg'] },
      { nome: 'calda viçosa', variacoes: ['kit 1L', '10L', '100L'] },
      { nome: 'calda bordalesa', variacoes: ['kit 1L', '10L', '100L'] },
    ],
    LESMICIDA: [{ nome: 'lesmarex 50g', variacoes: ['unidade'] }],
    FORMICIDA: [
      { nome: 'grão forte isca formicida 25g', variacoes: ['unidade'] },
      { nome: 'formicasa 10g', variacoes: ['unidade'] },
    ],
    INSETICIDA: [
      { nome: 'terra diatomáceas inseticida', variacoes: ['100g', '250g', '1kg', '5kg', '10kg'] },
      { nome: 'evidence 30g', variacoes: ['unidade'] },
      { nome: 'inseticom jardim neo sis', variacoes: ['unidade'] },
      { nome: 'óleo de neem', variacoes: ['300ml', '1L'] },
    ],
    ACARICIDA: [{ nome: 'enxofre agrícola solúvel 80%', variacoes: ['100g', '250g', '1kg'] }],
  },
  'SEMENTES (linha TopSeed Garden)': {
    'HORTALIÇAS EM GERAL': [
      { nome: 'agrião da agua folha larga', variacoes: ['pacote'] },
      { nome: 'couve manteiga da georgia', variacoes: ['pacote'] },
      { nome: 'couve-flor bola de neve', variacoes: ['pacote'] },
      { nome: 'pimentão all big', variacoes: ['pacote'] },
      { nome: 'repolho 60 dias', variacoes: ['pacote'] },
      { nome: 'rúcula folha larga', variacoes: ['pacote'] },
    ],
    TOMATES: [
      { nome: 'tomate especial para salada', variacoes: ['pacote'] },
      { nome: 'tomate italiano p. molhos', variacoes: ['pacote'] },
      { nome: 'tomate grape hibrido red sugar', variacoes: ['pacote'] },
      { nome: 'tomate hib. pepita f1', variacoes: ['pacote'] },
    ],
    FRUTAS: [
      { nome: 'mamão formosa', variacoes: ['pacote'] },
      { nome: 'melancia fairfax', variacoes: ['pacote'] },
      { nome: 'melão amarelo ouro', variacoes: ['pacote'] },
    ],
    ALFACES: [
      { nome: 'alface americana', variacoes: ['pacote'] },
      { nome: 'alface aurélia (manteiga)', variacoes: ['pacote'] },
      { nome: 'alface crespa para verão', variacoes: ['pacote'] },
      { nome: 'alface crespa roxa', variacoes: ['pacote'] },
    ],
    'ERVAS E TEMPEROS': [
      { nome: 'alecrim/rosmarinho', variacoes: ['pacote'] },
      { nome: 'cebolinha de tempero', variacoes: ['pacote'] },
      { nome: 'manjericão genovese', variacoes: ['pacote'] },
      { nome: 'orégano', variacoes: ['pacote'] },
      { nome: 'coentro verdão', variacoes: ['pacote'] },
      { nome: 'salsa lisa', variacoes: ['pacote'] },
    ],
    PIMENTAS: [
      { nome: 'pimenta bhut jolokia', variacoes: ['pacote'] },
      { nome: 'pimenta de cheiro do norte', variacoes: ['pacote'] },
      { nome: 'pimenta dedo de moca', variacoes: ['pacote'] },
      { nome: 'pimenta jalapeno', variacoes: ['pacote'] },
    ],
    ABÓBORAS: [
      { nome: 'abobora baiana tropical', variacoes: ['pacote'] },
      { nome: 'abobora hib. japonesa f1', variacoes: ['pacote'] },
      { nome: 'abobrinha caserta ts', variacoes: ['pacote'] },
      { nome: 'abobrinha menina brasileira', variacoes: ['pacote'] },
    ],
    'PARA GATOS': [
      { nome: 'erva dos gatos', variacoes: ['pacote'] },
      { nome: 'grama dos gatos', variacoes: ['pacote'] },
    ],
  },
  'VASOS E CONTENTORES': {
    'EMBALAGENS PLÁSTICOS PARA MUDAS': [
      { nome: 'embalagem plástica p/ mudas 3L', variacoes: ['unidade'] },
      { nome: 'embalagem plástica p/ mudas 5L', variacoes: ['unidade'] },
      { nome: 'embalagem plástica p/ mudas 8L', variacoes: ['unidade'] },
      { nome: 'embalagem plástica p mudas 14L', variacoes: ['unidade'] },
      { nome: 'embalagem plástica p mudas 40L', variacoes: ['unidade'] },
    ],
    'BANDEJAS PARA MUDAS / SEMENTEIRAS': [
      { nome: 'bandeja plástica mudas 15 cél.', variacoes: ['unidade'] },
      { nome: 'bandeja plástica mudas 50 cél.', variacoes: ['unidade'] },
      { nome: 'bandeja plástica mudas 128 cél', variacoes: ['unidade'] },
      { nome: 'bandeja plástica mudas 200 cél', variacoes: ['unidade'] },
    ],
    'VASOS RATAM': [
      { nome: 'vaso de ratam pote n.º 20', variacoes: ['unidade'] },
      { nome: 'vaso de ratam bacia n.º 21', variacoes: ['unidade'] },
      { nome: 'prato de de ratam n.º 20', variacoes: ['unidade'] },
    ],
    'VASOS DE COCO': [
      { nome: 'vaso de fibra de coco n.º 21', variacoes: ['unidade'] },
      { nome: 'cuia de fibra de coco n.º 19', variacoes: ['unidade'] },
      { nome: 'cesta fibra coco corrente nº30', variacoes: ['unidade'] },
    ],
    'VASOS DE CERÂMICA': [
      { nome: 'vaso cerâm bacia suculenta nº1', variacoes: ['unidade'] },
      { nome: 'vaso cerâ bacia rosa deser nº3', variacoes: ['unidade'] },
      { nome: 'vaso cerâm orquídea mesa nº3', variacoes: ['unidade'] },
      { nome: 'vaso cerâm orquídea tubo nº3', variacoes: ['unidade'] },
      { nome: 'prato cerâmi para vaso nº6', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica cachepô n.º 8', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica colonial n.º 2', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica areca n.º 1', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica aquário n.º 2', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica tubo n.º 2', variacoes: ['unidade'] },
      { nome: 'vaso cerâmica cilindro n.º 6', variacoes: ['unidade'] },
    ],
  },
  'IRRIGAÇÃO E REGA': {
    ASPERSORES: [
      { nome: 'aspersor para irrigação 25cm', variacoes: ['unidade'] },
      { nome: 'aspersor espiga giratório', variacoes: ['unidade'] },
      { nome: 'aspersor setorial de impulso', variacoes: ['unidade'] },
    ],
    'PISTOLAS E ESGUICHOS': [
      { nome: 'esguicho pistola plástica', variacoes: ['unidade'] },
      { nome: 'esguicho pistola 6 jatos', variacoes: ['unidade'] },
    ],
    REGADORES: [
      { nome: 'regador plástico com bico 5L', variacoes: ['unidade'] },
      { nome: 'regador plástico com bico 13L', variacoes: ['unidade'] },
    ],
    'MANGUEIRA PERFURADA': [
      { nome: 'mangueira santeno irrigação', variacoes: ['m linear'] },
      { nome: 'manguei santeno irrigação 100m', variacoes: ['rolo'] },
    ],
    GOTEJADOR: [{ nome: 'gotejador para garrafa pet', variacoes: ['unidade'] }],
  },
  FERRAMENTAS: {
    PULVERIZADORES: [
      { nome: 'pulveriza compressão prévia 2L', variacoes: ['unidade'] },
      { nome: 'pulverizdor lateral 5L', variacoes: ['unidade'] },
      { nome: 'pulverizador costal 20L', variacoes: ['unidade'] },
      { nome: 'pulverizador Para Garrafa Pet', variacoes: ['unidade'] },
    ],
    'FERRAMENTAS DE PODA': [
      { nome: 'tesoura de poda forjada', variacoes: ['unidade'] },
      { nome: 'tesourão de poda', variacoes: ['unidade'] },
      { nome: 'tesoura cerca viva / grama', variacoes: ['unidade'] },
      { nome: 'serrote pode poda master 12"', variacoes: ['unidade'] },
    ],
    'FERRAMENTAS PARA JARDIM': [
      { nome: 'sacho enchadinha coração cabo', variacoes: ['unidade'] },
      { nome: 'pazinha larga metálica cabo', variacoes: ['unidade'] },
      { nome: 'arrancador inço metálico cabo', variacoes: ['unidade'] },
      { nome: 'vassoura rastelo 22 dente cabo', variacoes: ['unidade'] },
    ],
  },
  'CULTIVO PROTEGIDO': {
    'TELAS DE SOMBREAMENTO': [
      { nome: 'tela sombrite 30% 3m largura', variacoes: ['m linear'] },
      { nome: 'tela sombrite 50% 3m largura', variacoes: ['m linear'] },
    ],
  },
  JARDINAGEM: {
    'LIMITADOR / SEPARADOR DE GRAMA': [
      { nome: 'limitador separador grama 10cm', variacoes: ['unidade'] },
    ],
    'PEDRAS DECORATIVAS': [
      {
        nome: 'granitina branca n.º 2',
        variacoes: ['250g', '500g', '2kg', '5kg', '10kg', '20kg', '40kg'],
      },
      {
        nome: 'granitina palha n.º 00',
        variacoes: ['250g', '500g', '2kg', '5kg', '10kg', '20kg', '40kg'],
      },
      { nome: 'mini seixo rolado n.º 1', variacoes: ['250g', '500g', '1kg', '5kg'] },
      { nome: 'seixo de mármore n.º 1', variacoes: ['1kg', '5kg', '15kg'] },
      { nome: 'seixo de rio', variacoes: ['1kg', '5kg', '15kg', '25kg'] },
    ],
    'CASCA DE PINUS': [
      { nome: 'casca de pinus polida P 40L', variacoes: ['unidade'] },
      { nome: 'casca de pinus natural', variacoes: ['15L', '35L'] },
      { nome: 'casca de pinus triturada M', variacoes: ['1l', '5L', '15L', '50L', '100L'] },
    ],
  },
  'HORMÔNIOS E ESTIMULANTES VEGETAIS': {
    'TALCO ENRAIZADOR': [
      { nome: 'talco enraizador 3000ppm AIB', variacoes: ['20g', '100g', '500g', '1kg'] },
      { nome: 'talco enraizador 6000 ppm AIB', variacoes: ['20g', '100g', '500g', '1kg'] },
    ],
    HORMÔNIOS: [{ nome: 'ácido indolbutírico AIB 1g', variacoes: ['unidade'] }],
  },
  DRENAGEM: {
    'MANTA DE DRENAGEM': [{ nome: 'manta drenagem bidim 1,08m', variacoes: ['m linear'] }],
    'ARGILA EXPANDIDA': [
      { nome: 'argila expandid cinasita 1506', variacoes: ['1L', '5L', '15L', '50L'] },
      { nome: 'argila expandid cinasita 2215', variacoes: ['1L', '5L', '15L', '50L'] },
      { nome: 'argila expandid cinasita 3222', variacoes: ['1L', '5L', '15L', '50L'] },
    ],
  },
  'CORRENTES E SUPORTES': {
    'SUPORTES DE PAREDE': [
      { nome: 'suporte parede A comum', variacoes: ['unidade'] },
      { nome: 'suporte parede artístico nº 02', variacoes: ['unidade'] },
      { nome: 'sup par violeta escada 3 lugar', variacoes: ['unidade'] },
      { nome: 'sup violeta vertical 3 lugar', variacoes: ['unidade'] },
    ],
    'SUPORTES DE MESA': [
      { nome: 'suporte margarida de mesa nº01', variacoes: ['unidade'] },
      { nome: 'suporte violeta mesa 3 vasos', variacoes: ['unidade'] },
      { nome: 'suporte de mesa n° 03', variacoes: ['unidade'] },
    ],
    'SUPORTE DE PISO COM RODAS': [
      { nome: 'suporte piso 3 rds pino 18 cm', variacoes: ['unidade'] },
      { nome: 'suporte piso 3 rds pino 24 cm', variacoes: ['unidade'] },
      { nome: 'suporte piso 4 rds pino 31 cm', variacoes: ['unidade'] },
    ],
    'SUPORTES DE PISO SEM RODAS': [
      { nome: 'suporte piso chapa nº 01 18 cm', variacoes: ['unidade'] },
      { nome: 'suporte piso aro nº 02 21 cm', variacoes: ['unidade'] },
      { nome: 'suporte piso aro nº 05 31 cm', variacoes: ['unidade'] },
    ],
    CORRENTES: [
      { nome: 'corrente simples 34 cm', variacoes: ['unidade'] },
      { nome: 'corrente simples 84 cm', variacoes: ['unidade'] },
      { nome: 'corrente violeta 3 lugares', variacoes: ['unidade'] },
    ],
    'ARAMES PARA ORQUÍDEAS': [
      { nome: 'arame orquídea encap. 3 pernas', variacoes: ['unidade'] },
      { nome: 'arame vaso orquídea 3 pernas', variacoes: ['unidade'] },
      { nome: 'arame vaso orquídea 4 pernas', variacoes: ['unidade'] },
    ],
    'CABO PARA VASOS': [
      { nome: 'cabo aço p/ vaso 3 pontas 45cm', variacoes: ['unidade'] },
      { nome: 'cabo aço p/ vaso 4 pontas 55cm', variacoes: ['unidade'] },
    ],
  },
};

const imagensGeradas = new Set<string>([
  'acido-borico-pkg.png',
  'adubo-viagra-orquidea-pkg.png',
  'adubo-viagra-rosas-pkg.png',
  'argila-expandida-pkg.png',
  'aspersor espiga giratório.jpeg',
  'aspersor para irrigação 25cm.jpeg',
  'aspersor setorial de impulso.jpeg',
  'bandeja plástica mudas 15.webp',
  'bandeja plástica mudas 50.webp',
  'bandeja plástica mudas 128.webp',
  'bandeja plástica mudas 200.webp',
  'bokashi-pkg.png',
  'calcario-dolomitico-pkg.png',
  'calda bordalesa.jpg',
  'calda viçosa.png',
  'celula-germinacao-jiffy-pkg.jpg',
  'coquetel-micronutrientes-pkg.png',
  'Embalagem Vaso 8 Litros.webp',
  'Embalagem Vaso Para Mudas 3 Litros.webp',
  'Vaso Embalagem 5 Litros.webp',
  'Vaso Embalagem De Mudas 14l.webp',
  'Vaso Embalagem De Mudas 50l.webp',
  'enxofre agrícola.png',
  'esguicho pistola plastica.jpg',
  'esguicho pistola 6 jatos.webp',
  'espuma-fenolica.jpeg',
  'esterco-gado-pkg.png',
  'esterco-galinha-pkg.png',
  'etiqueta plástica E08.png',
  'etiqueta plástica E11.jpg',
  'etiqueta plástica E16.png',
  'evidence-pkg.webp',
  'farinha-ossos-pkg.png',
  'ferro-quelatado-pkg.png',
  'fibra-coco-po-pkg.png',
  'formicasa-pkg.webp',
  'fte-br12-pkg.png',
  'gesso-agricola-pkg.png',
  'humus-minhoca-pkg.png',
  'limitador separador grama.webp',
  'mangueira santeno.webp',
  'manta-bidim-pkg.png',
  'map-mono-amonio-pkg.png',
  'musgo-sphagnum-pkg.png',
  'npk-10-10-10-pkg.png',
  'osmocote-14-14-14-pkg.png',
  'osmocote-15-09-12-pkg.png',
  'perlita-expandida-pkg.png',
  'plantafol-10-54-10-pkg.png',
  'plantafol-30-10-10-pkg.png',
  'sacos para mudas.jpg',
  'substrato-cactos-suculentas-pkg.png',
  'super-fosfato-simples-pkg.png',
  'talco.png',
  'tela-sombrite-pkg.png',
  'terra-diatomaceas-pkg.png',
  'torta-mamona-pkg.png',
  'torta-neem-pkg.png',
  'vaso-ceramica-suculenta-pkg.png',
  'vermiculita-expandida-pkg.png',
]);

const imagemPadrao = '/assets/images/products/generated/npk-10-10-10-pkg.png';

const imagemPorNomeSementes: Record<string, string> = {
  'agrião da agua folha larga': '/assets/images/products/sementes/agriao folha larga.webp',
  'alecrim/rosmarinho': '/assets/images/products/sementes/Alecrim-rosmarinho.jpg',
  'alface americana': '/assets/images/products/sementes/Alface americana.jpg',
  'alface aurélia (manteiga)': '/assets/images/products/sementes/Alface aurélia.jpg',
  'alface crespa para verão': '/assets/images/products/sementes/Alface crespa.jpeg',
  'alface crespa roxa': '/assets/images/products/sementes/Alface crespa roxa.jpg',
  'cebolinha de tempero': '/assets/images/products/sementes/Cebolinha de tempero.jpg',
  'erva dos gatos': '/assets/images/products/sementes/Erva dos gatos.jpg',
  'grama dos gatos': '/assets/images/products/sementes/Grama dos gatos.jpg',
  'melancia fairfax': '/assets/images/products/sementes/melancia.jpg',
  'pimenta bhut jolokia': '/assets/images/products/sementes/Pimenta bhut jolokia.jpg',
  'pimenta de cheiro do norte': '/assets/images/products/sementes/Pimenta de cheiro do norte.jpg',
  'tomate italiano p. molhos': '/assets/images/products/sementes/tomate italiano.jpg',
  'tomate especial para salada': '/assets/images/products/sementes/tomate.jpg',
  'abobora baiana tropical': '/assets/images/products/sementes/Abobora baiana tropical.jpg',
  'abobora hib. japonesa f1': '/assets/images/products/sementes/Abobora hib. japonesa f1.jpg',
  'abobrinha caserta ts': '/assets/images/products/sementes/Abobrinha Caserta.jpg',
  'abobrinha menina brasileira': '/assets/images/products/sementes/Abobrinha Menina Brasileira.jpg',
};

const imagemPorNomeVasosArames: Record<string, string> = {
  'arame vaso orquídea 3 pernas':
    '/assets/images/products/vasos-arames/Arame Vaso Orquídea 3 Pernas.webp',
  'arame vaso orquídea 4 pernas':
    '/assets/images/products/vasos-arames/Arame Vaso Orquídea 4 Pernas.webp',
  'arame orquídea encap. 3 pernas':
    '/assets/images/products/vasos-arames/arame orquídea encap. 3 pernas.jpeg',
  'cabo aço p/ vaso 3 pontas 45cm':
    '/assets/images/products/vasos-arames/Cabo Aço  Vaso 3 Pontas 45cm.webp',
  'cabo aço p/ vaso 4 pontas 55cm':
    '/assets/images/products/vasos-arames/Cabo Aço  Vaso 4 Pontas 55cm.webp',
  'vaso cerâm orquídea tubo nº3':
    '/assets/images/products/vasos-arames/Vaso Cerâm Orquídea Tubo.webp',
  'vaso cerâmica aquário n.º 2': '/assets/images/products/vasos-arames/Vaso Cerâmica Aquário.webp',
  'vaso cerâmica areca n.º 1': '/assets/images/products/vasos-arames/Vaso Cerâmica Areca.webp',
  'vaso cerâmica cilindro n.º 6':
    '/assets/images/products/vasos-arames/Vaso Cerâmica Cilindro N.º 6.webp',
  'vaso cerâmica colonial n.º 2':
    '/assets/images/products/vasos-arames/Vaso Cerâmica Colonial N.º 2.webp',
  'prato cerâmi para vaso nº6': '/assets/images/products/vasos-arames/Prato Cerâmi Para Vaso.jpg',
};

const imagemPorNomeNovasFotos: Record<string, string> = {
  'arrancador inço metálico cabo':
    '/assets/images/products/novas-fotos/Arrancador Inço Metálico Cabo.webp',
  'carvão triturado': '/assets/images/products/novas-fotos/Carvão Triturado.webp',
  'casca de arroz carbonizada':
    '/assets/images/products/novas-fotos/Casca De Arroz Carbonizada.webp',
  'casca de pinus natural': '/assets/images/products/novas-fotos/Casca de pinus.jpg',
  'casca de pinus polida P 40L':
    '/assets/images/products/novas-fotos/Casca De Pinus Polida P 40l.webp',
  'casca de pinus triturada M':
    '/assets/images/products/novas-fotos/Casca De Pinus Triturada M.webp',
  'cesta fibra coco corrente nº30':
    '/assets/images/products/novas-fotos/Cesta Fibra Coco Corrente Nº30.webp',
  'chips de coco': '/assets/images/products/novas-fotos/Chips De Coco.jpeg',
  'coentro verdão': '/assets/images/products/novas-fotos/Coentro Verdão.jpg',
  'corrente simples 34 cm': '/assets/images/products/novas-fotos/Corrente Simples 34 Cm.webp',
  'corrente simples 84 cm': '/assets/images/products/novas-fotos/Corrente Simples 84 Cm.webp',
  'couve manteiga da georgia': '/assets/images/products/novas-fotos/Couve Manteiga Da Georgia.webp',
  'couve-flor bola de neve': '/assets/images/products/novas-fotos/Couve-flor Bola De Neve.webp',
  'cuia de fibra de coco n.º 19':
    '/assets/images/products/novas-fotos/cuia de fibra de coco n.º 19.jpg',
  'glifomato 10 flaconetes 3ml': '/assets/images/products/novas-fotos/Glifomato.webp',
  'gotejador para garrafa pet':
    '/assets/images/products/novas-fotos/Gotejador Para Garrafa Pet.webp',
  'granitina branca n.º 2': '/assets/images/products/novas-fotos/Granitina Branca N.º 2.webp',
  'grão forte isca formicida 25g':
    '/assets/images/products/novas-fotos/Grão Forte Isca Formicida 25g.webp',
  'inseticom jardim neo sis': '/assets/images/products/novas-fotos/inseticom.jpg',
  'lesmarex 50g': '/assets/images/products/novas-fotos/Lesmarex 50g.webp',
  'mamão formosa': '/assets/images/products/novas-fotos/Mamão Formosa.webp',
  'manjericão genovese': '/assets/images/products/novas-fotos/Manjericão Genovese.webp',
  'mata tiririca herbicida selet': '/assets/images/products/novas-fotos/mata tiririca.jpg',
  'melão amarelo ouro': '/assets/images/products/novas-fotos/Melão Amarelo Ouro.webp',
  'mini seixo rolado n.º 1': '/assets/images/products/novas-fotos/mini seixo.webp',
  'óleo de neem': '/assets/images/products/novas-fotos/Óleo De Neem.jpeg',
  orégano: '/assets/images/products/novas-fotos/Orégano.jfif',
  'pazinha larga metálica cabo':
    '/assets/images/products/novas-fotos/Pazinha Larga Metálica Cabo.webp',
  'pimenta dedo de moca': '/assets/images/products/novas-fotos/Pimenta Dedo De Moca.jfif',
  'pimenta jalapeno': '/assets/images/products/novas-fotos/Pimenta Jalapeno.jfif',
  'pimentão all big': '/assets/images/products/novas-fotos/Pimentão All Big.jfif',
  'pó de carvão biochar': '/assets/images/products/novas-fotos/Pó De Carvão Biochar.webp',
  'pulveriza compressão prévia 2L':
    '/assets/images/products/novas-fotos/Pulveriza Compressão Prévia 2l.webp',
  'pulverizador costal 20L': '/assets/images/products/novas-fotos/Pulverizador costal.webp',
  'pulverizador Para Garrafa Pet':
    '/assets/images/products/novas-fotos/Pulverizador Para Garrafa Pet.webp',
  'pulverizdor lateral 5L': '/assets/images/products/novas-fotos/Pulverizador lateral 5L.webp',
  'regador plástico com bico 13L':
    '/assets/images/products/novas-fotos/Regador Plástico Com Bico 13l.webp',
  'regador plástico com bico 5L':
    '/assets/images/products/novas-fotos/Regador Plástico Com Bico 5l.webp',
  'repolho 60 dias': '/assets/images/products/novas-fotos/Repolho 60 Dias.jfif',
  'rúcula folha larga': '/assets/images/products/novas-fotos/Rúcula Folha Larga.jfif',
  'sacho enchadinha coração cabo': '/assets/images/products/novas-fotos/Sacho.webp',
  'salsa lisa': '/assets/images/products/novas-fotos/Salsa Lisa.jfif',
  'seixo de mármore n.º 1': '/assets/images/products/novas-fotos/Seixo De Mármore N.º 1.webp',
  'seixo de rio': '/assets/images/products/novas-fotos/Seixo De Rio.webp',
  'serrote pode poda master 12"':
    '/assets/images/products/novas-fotos/Serrote Pode Poda Master 12.webp',
  'solução hidropônica frutos 2':
    '/assets/images/products/novas-fotos/solução hidropônica frutos 2.jpg',
  'substrato plantas plante mais':
    '/assets/images/products/novas-fotos/Substrato Plantas Plante Mais.webp',
  'suporte parede A comum':
    '/assets/images/products/novas-fotos/suporte parede A comum.png',
  'suporte piso 3 rds pino 18 cm':
    '/assets/images/products/fotos-tiradas/suporte piso 3 rds pino 24 cm.png',
  'suporte piso aro nº 02 21 cm':
    '/assets/images/products/novas-fotos/suporte piso aro nº 02 21 cm.jpg',
  'terra vegetal adubada': '/assets/images/products/novas-fotos/Terra Vegetal Adubada.webp',
  'vaso de ratam pote n.º 20':
    '/assets/images/products/novas-fotos/vaso de ratam pote n.º 20.jpg',
  'tesoura cerca viva / grama': '/assets/images/products/novas-fotos/Tesoura Cerca Viva Grama.webp',
  'tesoura de poda forjada': '/assets/images/products/novas-fotos/Tesoura De Poda Forjada.webp',
  'tomate grape hibrido red sugar':
    '/assets/images/products/novas-fotos/Tomate Grape Hibrido Red Sugar.webp',
  'tomate hib. pepita f1': '/assets/images/products/novas-fotos/Tomate Hib. Pepita F1.webp',
  'turfa de sphagnum ph 6.5': '/assets/images/products/novas-fotos/Turfa De Sphagnum Ph 6.5.webp',
};

const imagemPorNomeFotosTiradas: Record<string, string> = {
  'corrente violeta 3 lugares':
    '/assets/images/products/fotos-tiradas/Corrente Violeta 3 Lugares.webp',
  'ácido indolbutírico AIB 1g':
    '/assets/images/products/fotos-tiradas/acido indolbutirico AIB 1g.png',
  'granitina palha n.º 00':
    '/assets/images/products/fotos-tiradas/granitina palha n.º 00.png',
  'nitrato de cálcio': '/assets/images/products/fotos-tiradas/nitrato de cálcio.png',
  'NPK granulado 04.14.08':
    '/assets/images/products/fotos-tiradas/NPK granulado 04 14 08.png',
  'solução hidropônica folhosas':
    '/assets/images/products/fotos-tiradas/solução hidropônica folhosas.png',
  'solução hidropônica frutos 1':
    '/assets/images/products/fotos-tiradas/solução hidropônica frutos 1.png',
  'substrato bioplant plus':
    '/assets/images/products/fotos-tiradas/substrato bioplant plus.png',
  'substrato carolina soil':
    '/assets/images/products/fotos-tiradas/substrato carolina soil.png',
  'substrato p/ orquídeas tipo 1':
    '/assets/images/products/fotos-tiradas/substrato p orquídeas tipo 1.png',
  'substrato rosas do deserto':
    '/assets/images/products/fotos-tiradas/substrato rosas do deserto.png',
  'sulfato de magnésio': '/assets/images/products/fotos-tiradas/sulfato de magnésio.png',
  'sulfato de zinco': '/assets/images/products/fotos-tiradas/sulfato de zinco.png',
  'sup par violeta escada 3 lugar':
    '/assets/images/products/fotos-tiradas/sup par violeta escada 3 lugar.png',
  'sup violeta vertical 3 lugar':
    '/assets/images/products/fotos-tiradas/sup violeta vertical 3 lugar.png',
  'suporte de mesa n° 03':
    '/assets/images/products/fotos-tiradas/suporte de mesa nº 03.png',
  'suporte margarida de mesa nº01':
    '/assets/images/products/fotos-tiradas/suporte margarida de mesa n°01.png',
  'suporte parede artístico nº 02':
    '/assets/images/products/fotos-tiradas/suporte parede artístico nº 02.png',
  'suporte piso 3 rds pino 24 cm':
    '/assets/images/products/fotos-tiradas/suporte piso 3 rds pino 24 cm.png',
  'suporte piso 4 rds pino 31 cm':
    '/assets/images/products/fotos-tiradas/suporte piso 4 rds pino 31 cm.png',
  'suporte piso aro nº 05 31 cm':
    '/assets/images/products/fotos-tiradas/suporte piso aro nº 05 31 cm.png',
  'suporte piso chapa nº 01 18 cm':
    '/assets/images/products/fotos-tiradas/suporte piso chapa nº 01 18 cm.png',
  'suporte violeta mesa 3 vasos':
    '/assets/images/products/fotos-tiradas/suporte violeta mesa 3 vasos.png',
  'tesourão de poda': '/assets/images/products/fotos-tiradas/tesourão de poda.png',
  'vaso cerâm bacia suculenta nº1':
    '/assets/images/products/fotos-tiradas/vaso cerâm bacia suculenta n°1.png',
  'vaso cerâm orquídea mesa nº3':
    '/assets/images/products/fotos-tiradas/vaso cerâm orquídea mesa n°3.png',
  'vaso cerâmica cachepô n.º 8':
    '/assets/images/products/fotos-tiradas/vaso cerâmica cachepô n.º 8.png',
  'vaso cerâmica tubo n.º 2':
    '/assets/images/products/fotos-tiradas/vaso cerâmica tubo n.º 2.png',
  'vaso de fibra de coco n.º 21':
    '/assets/images/products/fotos-tiradas/vaso de fibra de coco n.º 21.png',
  'vassoura rastelo 22 dente cabo':
    '/assets/images/products/fotos-tiradas/vassoura rastelo 22 dente cabo.png',
  'vermiculita expand super fina':
    '/assets/images/products/fotos-tiradas/vermiculita expand super fina.png',
  'yoorim master': '/assets/images/products/fotos-tiradas/yoorim master.png',
  'prato de de ratam n.º 20':
    '/assets/images/products/fotos-tiradas/Prato De De Ratam N.º 20.png',
  'vaso de ratam bacia n.º 21':
    '/assets/images/products/fotos-tiradas/Vaso De Ratam Bacia N.º 21.png',
  'suporte parede A comum':
    '/assets/images/products/fotos-tiradas/suporte parede A comum.png',
};

const imagemPorNome: Record<string, string> = {
  'ácido bórico': 'acido-borico-pkg.png',
  'adubo orgânic viagra orquídea': 'adubo-viagra-orquidea-pkg.png',
  'adubo viagra rosas do deserto': 'adubo-viagra-rosas-pkg.png',
  'argila expandid cinasita 1506': 'argila-expandida-pkg.png',
  'argila expandid cinasita 2215': 'argila-expandida-pkg.png',
  'argila expandid cinasita 3222': 'argila-expandida-pkg.png',
  'aspersor para irrigação 25cm': 'aspersor para irrigação 25cm.jpeg',
  'aspersor espiga giratório': 'aspersor espiga giratório.jpeg',
  'aspersor setorial de impulso': 'aspersor setorial de impulso.jpeg',
  'bandeja plástica mudas 15 cél.': 'bandeja plástica mudas 15.webp',
  'bandeja plástica mudas 50 cél.': 'bandeja plástica mudas 50.webp',
  'bandeja plástica mudas 128 cél': 'bandeja plástica mudas 128.webp',
  'bandeja plástica mudas 200 cél': 'bandeja plástica mudas 200.webp',
  'bokashi': 'bokashi-pkg.png',
  'calcário dolomítico filler': 'calcario-dolomitico-pkg.png',
  'calda bordalesa': 'calda bordalesa.jpg',
  'calda viçosa': 'calda viçosa.png',
  'célu germinação jiffy 25x35mm': 'celula-germinacao-jiffy-pkg.jpg',
  'célu germinação jiffy 42x75mm': 'celula-germinacao-jiffy-pkg.jpg',
  'coquetel de micronutrientes': 'coquetel-micronutrientes-pkg.png',
  'embalagem plástica p/ mudas 3L': 'Embalagem Vaso Para Mudas 3 Litros.webp',
  'embalagem plástica p/ mudas 5L': 'Vaso Embalagem 5 Litros.webp',
  'embalagem plástica p/ mudas 8L': 'Embalagem Vaso 8 Litros.webp',
  'embalagem plástica p mudas 14L': 'Vaso Embalagem De Mudas 14l.webp',
  'embalagem plástica p mudas 40L': 'Vaso Embalagem De Mudas 50l.webp',
  'enxofre agrícola solúvel 80%': 'enxofre agrícola.png',
  'esguicho pistola plástica': 'esguicho pistola plastica.jpg',
  'esguicho pistola 6 jatos': 'esguicho pistola 6 jatos.webp',
  'espuma fenólica 2x2x2Cm rúcula': 'espuma-fenolica.jpeg',
  'espuma fenólica 2x2x3cm alface': 'espuma-fenolica.jpeg',
  'espuma fenólica 2x2x3cm sem f': 'espuma-fenolica.jpeg',
  'espuma fenólica 2x2x3cm rúcula': 'espuma-fenolica.jpeg',
  'esterco de gado': 'esterco-gado-pkg.png',
  'esterco de galinha': 'esterco-galinha-pkg.png',
  'etiqueta identifica mudas E08': 'etiqueta plástica E08.png',
  'etiqueta identifica mudas E11': 'etiqueta plástica E11.jpg',
  'etiqueta identifica mudas E16': 'etiqueta plástica E16.png',
  'evidence 30g': 'evidence-pkg.webp',
  'farinha de ossos': 'farinha-ossos-pkg.png',
  'ferro quelatado - Ferrilene': 'ferro-quelatado-pkg.png',
  'fibra de coco em pó': 'fibra-coco-po-pkg.png',
  'formicasa 10g': 'formicasa-pkg.webp',
  'FTE BR12 - cmicronutrientes': 'fte-br12-pkg.png',
  'gesso agrícola': 'gesso-agricola-pkg.png',
  'húmus de minhoca': 'humus-minhoca-pkg.png',
  'limitador separador grama 10cm': 'limitador separador grama.webp',
  'mangueira santeno irrigação': 'mangueira santeno.webp',
  'manguei santeno irrigação 100m': 'mangueira santeno.webp',
  'manta drenagem bidim 1,08m': 'manta-bidim-pkg.png',
  'mono amônio fosfato - MAP': 'map-mono-amonio-pkg.png',
  'musgo sphagnum desidratad rosa': 'musgo-sphagnum-pkg.png',
  'NPK granulado 10.10.10': 'npk-10-10-10-pkg.png',
  'osmocote 14.14.14 3M': 'osmocote-14-14-14-pkg.png',
  'osmocote 15.09.12 + micros 3M': 'osmocote-15-09-12-pkg.png',
  'perlita expandida': 'perlita-expandida-pkg.png',
  'NPK solúve plantafol 10.54.10': 'plantafol-10-54-10-pkg.png',
  'NPK solúve plantafol 30.10.10': 'plantafol-30-10-10-pkg.png',
  'saco para mudas 12 x 12': 'sacos para mudas.jpg',
  'saco para mudas 13 x 19': 'sacos para mudas.jpg',
  'saco para mudas 16 x 25': 'sacos para mudas.jpg',
  'saco para mudas 20 x 35': 'sacos para mudas.jpg',
  'substrato cactos e suculentas': 'substrato-cactos-suculentas-pkg.png',
  'super fosfato simples': 'super-fosfato-simples-pkg.png',
  'talco enraizador 3000ppm AIB': 'talco.png',
  'talco enraizador 6000 ppm AIB': 'talco.png',
  'tela sombrite 30% 3m largura': 'tela-sombrite-pkg.png',
  'tela sombrite 50% 3m largura': 'tela-sombrite-pkg.png',
  'terra diatomáceas inseticida': 'terra-diatomaceas-pkg.png',
  'torta de mamona': 'torta-mamona-pkg.png',
  'torta de neem': 'torta-neem-pkg.png',
  'vaso cerâ bacia rosa deser nº3': 'vaso-ceramica-suculenta-pkg.png',
  'vermiculita expandida grossa': 'vermiculita-expandida-pkg.png',
};

const descricaoPorNome: Record<string, string> = {
  'solução hidropônica folhosas':
    'Kit balanceado contendo 6 sais para o cultivo de hortaliças folhosas pelo sistema de hidroponia.',
  'solução hidropônica frutos 1':
    'Kit balanceado contendo 7 sais para o cultivo de hortaliças de frutos tipo 1 (solanáceas) pelo sistema de hidroponia.',
  'solução hidropônica frutos 2':
    'Kit balanceado contendo 6 sais para o cultivo de hortaliças de frutos tipo 2 (frutos sólidos) pelo sistema de hidroponia',
  'ácido bórico':
    'Rico em boro (16,7%), é essencial para o crescimento das plantas, e também ajuda na formação e pegamento das flores.',
  'mono amônio fosfato - MAP':
    'Rico em nitrogênio (11%) e fósforo (60%). Promove raízes fortes, rápido estabelecimento e bom crescimento vegetativo.',
  'nitrato de cálcio':
    'Rico em nitrogênio (15,5%) e cálcio (19%). Promove forte crescimento das plantas, e melhor qualidade dos frutos.',
  'sulfato de magnésio':
    'Rico em magnésio (9%) e enxofre (12%). Auxilia no crescimento das plantas, aumento sua resistência.',
  'sulfato de zinco':
    'Rico em zinco (20%) e enxofre (10%). Estimula o crescimento, cria resistência a doenças, e otimiza a qualidade de frutos',
  'FTE BR12 - cmicronutrientes':
    'Coquetel de micronutrientes para aplicação direta no solo, contendo os nutrientes: S, B, Cu, Mn, Zn e Mo.',
  'NPK granulado 10.10.10':
    'Adubo coringa para o solo, pois tem quantidades equilibradas de nitrogênio, fósforo e potássio.',
  'NPK granulado 14.14.14':
    'Adubo para solo, com uma maior concentração de fósforo, que ajuda na floração das plantas.',
  'yoorim master':
    'Fosfato natural de rocha, rico em fósforo, cálcio, magnésio, silício e micronutrientes na forma de fritas.',
  'NPK solúve plantafol 10.54.10':
    'Rico em fósforo, é indicado para a fase de floração. Pode ser aplicado diretamente no solo, fertirrigação ou foliar.',
  'NPK solúve plantafol 30.10.10':
    'Rico em nitrogênio, é indicado para a fase de crescimento. Pode ser aplicado no solo, fertirrigação ou foliar.',
  'coquetel de micronutrientes':
    'Coquetel de micronutrientes solúvel contendo os nutrientes: S, Mg, B, Mn, Mo, Zn e agente complexante.',
  'ferro quelatado - Ferrilene':
    'Contem 6% de ferro + 40,8% de agente quelante EDDHA. Fonte de ferra de fácil assimilação pelas plantas.',
  'calcário dolomítico filler':
    'Corretivo de acidez do solo com PRNT 100%, o que garante um rápido efeito corretivo. Rico em cálcio e magnésio.',
  'gesso agrícola':
    'Melhorar o ambiente do solo em profundidade, corrigindo a toxicidade do alumínio e fornecendo cálcio e enxofre.',
  'super fosfato simples':
    'Rico em fósforo (18%), é recomendado para fornecimento deste nutriente às plantas, ou correção de sua deficiência no solo',
  'osmocote 14.14.14 3M':
    'Adubo de liberação lenta - fornece nutrientes por 3 meses, com concentração equilibrada de nitrogênio fósforo e potássio',
  'osmocote 15.09.12 + micros 3M':
    'Adubo de liberação lenta - fornece nutrientes por 3 meses, que promove o crescimento das raízes a caules das plantas.',
  'esterco de gado':
    'Produto curtido de gado confinado - livre de sementes de ervas daninhas. Fornece nutrientes e estrutura o solo.',
  'esterco de galinha':
    '100% puro, curtido, sem palha ou contaminantes. Além de fornecer nutrientes, ajuda a estruturar o solo.',
  'farinha de ossos':
    'Produto resultante da moagem de ossos secos, rico em cálcio e fósforo. Ótimo para plantas floríferas.',
  'húmus de minhoca':
    'Um dos melhores e mais ricos adubos orgânicos que existem. Oriundo de esterco de gado puro de confinamento.',
  'torta de mamona':
    'Adubo orgânico originado da prensa da mamona, rico em nitrogênio. Contribui com a melhor produção de folhas e flores.',
  'torta de neem':
    'Fertilizante orgânico rico em matéria orgânica, nitrogênio e micronutrientes. Função de adubação e defensivo natural.',
  'adubo orgânic viagra orquídea':
    'Mistura de 5 adubos orgânicos: 3 de origem animal e 2 de origem vegetal - reúne os benefícios de todos eles. Super fino.',
  'adubo viagra rosas do deserto':
    'Mistura de 5 adubos orgânicos: 3 de origem animal e 2 de origem vegetal - reúne os benefícios de todos eles. Super fino.',
  bokashi:
    'Talvez o melhor adubo orgânico que existe. Produto "vivo", com microorganismos benéficos, além de rico em nutrientes.',
  'musgo sphagnum desidratad rosa':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'carvão triturado':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'casca de arroz carbonizada':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'casca de pinus triturada M':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'chips de coco':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'fibra de coco em pó':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'perlita expandida':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'pó de carvão biochar':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'turfa de sphagnum ph 6.5':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'vermiculita expandida grossa':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'vermiculita expand super fina':
    'Substrato base, a ser misturado a outros, para a composição de substratos destinado aos mais variados tipos de plantas.',
  'substrato carolina soil':
    'Substrato da linha profissional, indicado para a germinação de sementes, e cultivo da mais variada gama de plantas.',
  'substrato bioplant plus':
    'Substrato da linha profissional, indicado para a germinação de sementes, e cultivo da mais variada gama de plantas.',
  'substrato cactos e suculentas':
    'Desenvolvido especialmente para cactos e suculentas, apresentando ótima drenagem, e rico em nutrientes.',
  'substrato p/ orquídeas tipo 1':
    'Composto de casca de pinus triturada + crush de coco + munha de carvão, tem ótima drenagem, aeração e longevidade.',
  'substrato plantas plante mais':
    'Substrato à base de pó de coco recomendado para o cultivo de todas as plantas. É leve, bem drenado e bem aerado.',
  'substrato rosas do deserto':
    'Desenvolvido especialmente para rosas do deserto, apresentando ótima drenagem, e rico em fósforo e outros nutrientes.',
  'terra vegetal adubada':
    'Terra preta com ph corrigido, acrescida de adubos orgânicos e químicos. Totalmente isenta de sementes de ervas daninhas.',
  'espuma fenólica 2x2x2Cm rúcula':
    'Substrato estéril livre de fungos e bactérias para produção de mudas de alta qualidade. Evita estresse no transplante.',
  'espuma fenólica 2x2x3cm alface':
    'Substrato estéril livre de fungos e bactérias para produção de mudas de alta qualidade. Evita estresse no transplante.',
  'espuma fenólica 2x2x3cm sem f':
    'Substrato estéril livre de fungos e bactérias para produção de mudas de alta qualidade. Evita estresse no transplante.',
  'espuma fenólica 2x2x3cm rúcula':
    'Substrato estéril livre de fungos e bactérias para produção de mudas de alta qualidade. Evita estresse no transplante.',
  'célu germinação jiffy 25x35mm':
    'Uma rede fina de material vegetal preenchida com turfa. É ideal para a germinação de sementes e enraizamento de estacas.',
  'célu germinação jiffy 42x75mm':
    'Uma rede fina de material vegetal preenchida com turfa. É ideal para a germinação de sementes e enraizamento de estacas.',
  'etiqueta identifica mudas E08':
    'Utilizadas para identificar plantas, catalogar espécies, ou fazer anotações do uso de fertilizantes ou defensivos.',
  'etiqueta identifica mudas E11':
    'Utilizadas para identificar plantas, catalogar espécies, ou fazer anotações do uso de fertilizantes ou defensivos.',
  'etiqueta identifica mudas E16':
    'Utilizadas para identificar plantas, catalogar espécies, ou fazer anotações do uso de fertilizantes ou defensivos.',
  'saco para mudas 12 x 12':
    'Produto de qualidade para produção de mudas, resistente, prático e durável. Fabricados com furos, para drenagem de água.',
  'saco para mudas 13 x 19':
    'Produto de qualidade para produção de mudas, resistente, prático e durável. Fabricados com furos, para drenagem de água.',
  'saco para mudas 16 x 25':
    'Produto de qualidade para produção de mudas, resistente, prático e durável. Fabricados com furos, para drenagem de água.',
  'saco para mudas 20 x 35':
    'Produto de qualidade para produção de mudas, resistente, prático e durável. Fabricados com furos, para drenagem de água.',
  'glifomato 10 flaconetes 3ml':
    'Herbicida não seletivo (afeta todas as plantas) que contém 10% de glifosato. Ótimo para erradicar ervas daninhas.',
  'mata tiririca herbicida selet':
    'Mata mato (herbicida) seletivo que afeta somente a tiririca. Ótimo para ser usado em áreas gramadas infestadas.',
  'enxofre agrícola solúvel 80%':
    'Fungicida e acaricida solúvel com ação de contato para aplicação foliar em todos os tipos e plantas.',
  'calda viçosa':
    'Fungicida e acaricida solúvel com ação de contato para aplicação foliar em todos os tipos e plantas.',
  'calda bordalesa':
    'Fungicida agrícola natural eficiente contra diversas doenças fúngicas e também ação bactericida e repelência para pragas',
  'lesmarex 50g':
    'Lesmicida que controla lesmas e caracóis. Seu atrativo leva as pragas a consumi-lo, o que provoca sua morte.',
  'grão forte isca formicida 25g':
    'Formicida isca para controle de formigas cortadeiras. Seu atrativo faz com que seja carregado para dentro do ninho.',
  'formicasa 10g':
    'Inseticida que elimina baratas, formigas e cupins. Contendo atrativos naturais, são carregados para dentro dos ninhos.',
  'terra diatomáceas inseticida':
    'Pó natural rico em sílica com ação inseticida natural, capaz de desidratar e eliminar pragas de forma eficiente e segura',
  'evidence 30g':
    'Inseticida sistêmico que elimina com eficiência diversas pragas: cochonilhas, cupim, pulgão, trips, mosca branca, etc...',
  'inseticom jardim neo sis':
    'Inseticida sistêmico em grânulos solúveis, eficaz no controle de Pulgões, Cochonilhas, Lagartas, Moscas e Mosquitos.',
  'óleo de neem':
    'Inseticida orgânico com 9 compostos bioativos de ação inseticida cientificamente comprovada. Controla mais de 100 pragas',
  'agrião da agua folha larga':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'couve manteiga da georgia':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'couve-flor bola de neve':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'pimentão all big':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'repolho 60 dias':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'rúcula folha larga':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'tomate especial para salada':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'tomate italiano p. molhos':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'tomate grape hibrido red sugar':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'tomate hib. pepita f1':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'mamão formosa':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'melancia fairfax':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'melão amarelo ouro':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'alface americana':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'alface aurélia (manteiga)':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'alface crespa para verão':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'alface crespa roxa':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'alecrim/rosmarinho':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'cebolinha de tempero':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'manjericão genovese':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  orégano:
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'coentro verdão':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'salsa lisa':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'pimenta bhut jolokia':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'pimenta de cheiro do norte':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'pimenta dedo de moca':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'pimenta jalapeno':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'abobora baiana tropical':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'abobora hib. japonesa f1':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'abobrinha caserta ts':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'abobrinha menina brasileira':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'erva dos gatos':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'grama dos gatos':
    'Linha TopSeed Garden, líder mundial na produção de sementes Maior vigor e germinação, originando plantas mais produtivas',
  'embalagem plástica p/ mudas 3L':
    'Embalagem para o cultivo e desenvolvimento das mais variadas espécies de plantas, flores e hortaliças.',
  'embalagem plástica p/ mudas 5L':
    'Embalagem para o cultivo e desenvolvimento das mais variadas espécies de plantas, flores e hortaliças.',
  'embalagem plástica p/ mudas 8L':
    'Embalagem para o cultivo e desenvolvimento das mais variadas espécies de plantas, flores e hortaliças.',
  'embalagem plástica p mudas 14L':
    'Embalagem para o cultivo e desenvolvimento das mais variadas espécies de plantas, flores e hortaliças.',
  'embalagem plástica p mudas 40L':
    'Embalagem para o cultivo e desenvolvimento das mais variadas espécies de plantas, flores e hortaliças.',
  'bandeja plástica mudas 15 cél.':
    'Utilizada no cultivo de diferentes tipos de plantas, flores e hortaliças.Oferece facilidade na semeadura e manuseio.',
  'bandeja plástica mudas 50 cél.':
    'Utilizada no cultivo de diferentes tipos de plantas, flores e hortaliças.Oferece facilidade na semeadura e manuseio.',
  'bandeja plástica mudas 128 cél':
    'Utilizada no cultivo de diferentes tipos de plantas, flores e hortaliças.Oferece facilidade na semeadura e manuseio.',
  'bandeja plástica mudas 200 cél':
    'Utilizada no cultivo de diferentes tipos de plantas, flores e hortaliças.Oferece facilidade na semeadura e manuseio.',
  'vaso de ratam pote n.º 20':
    'Vaso plástico envolto com ratam sintético de várias cores. Ideal para suas plantas. Um toque especial ao seu ambiente.',
  'vaso de ratam bacia n.º 21':
    'Vaso plástico envolto com ratam sintético de várias cores. Ideal para suas plantas. Um toque especial ao seu ambiente.',
  'prato de de ratam n.º 20':
    'Vaso plástico envolto com ratam sintético de várias cores. Ideal para suas plantas. Um toque especial ao seu ambiente.',
  'vaso de fibra de coco n.º 21':
    'Xaxim ecológico fabricado de fibra de coco. Serve para qualquer planta, e dá um toque especial ao seu ambiente.',
  'cuia de fibra de coco n.º 19':
    'Xaxim ecológico fabricado de fibra de coco. Serve para qualquer planta, e dá um toque especial ao seu ambiente.',
  'cesta fibra coco corrente nº30':
    'Cesta de arame com corrente revestida com manta de fibra de coco. Ótimo para samambaias e outras plantas pendentes.',
  'vaso cerâm bacia suculenta nº1':
    'Vaso artesanal de cerâmica (barro), no formato de bacia fechada. Ótimo para arranjos de suculentas e outras plantas.',
  'vaso cerâ bacia rosa deser nº3':
    'Vaso artesanal de cerâmica (barro), no formato de bacia aberta. Ótimo para rosas do deserto, ou qualquer outra planta.',
  'vaso cerâm orquídea mesa nº3':
    'Vaso artesanal de cerâmica (barro) especial para orquídeas, no formato tradicional. Furado nas laterais para drenagem.',
  'vaso cerâm orquídea tubo nº3':
    'Vaso artesanal de cerâmica (barro) especial para orquídeas, no formato de tubo. Furado nas laterais para drenagem.',
  'prato cerâmi para vaso nº6':
    'Prato artesanal de cerâmica (barro), para ser colocado em baixo de vasos - evita que a sobra da água da rega se espalhe.',
  'vaso cerâmica cachepô n.º 8':
    'Prato artesanal de cerâmica (barro), para ser colocado em baixo de vasos - evita que a sobra da água da rega se espalhe.',
  'vaso cerâmica colonial n.º 2':
    'Vaso artesanal de cerâmica (barro), modelo colonial / tradicional - um toque especial para seu ambiente.',
  'vaso cerâmica areca n.º 1':
    'Vaso artesanal de cerâmica (barro), modelo areca - um toque especial para seu ambiente. Serve para todas as plantas.',
  'vaso cerâmica aquário n.º 2':
    'Vaso artesanal de cerâmica (barro), modelo aquário - um toque especial para seu ambiente. Serve para todas as plantas.',
  'vaso cerâmica tubo n.º 2':
    'Vaso artesanal de cerâmica (barro), modelo tubo - um toque especial para seu ambiente. Serve para todas as plantas.',
  'vaso cerâmica cilindro n.º 6':
    'Vaso artesanal de cerâmica (barro), modelo cilindro - um toque especial para seu ambiente. Serve para todas as plantas.',
  'aspersor para irrigação 25cm':
    'Mantenha seu jardim irrigado com profissionalismo utilizando este aspersor de primeira linha. Para gramados e canteiros.',
  'aspersor espiga giratório':
    'Mantenha seu jardim irrigado com profissionalismo utilizando este aspersor de primeira linha. Para gramados e canteiros.',
  'aspersor setorial de impulso':
    'Mantenha seu jardim irrigado com profissionalismo utilizando este aspersor de primeira linha. Para gramados e canteiros.',
  'esguicho pistola plástica':
    'Pistola que facilita tanto a rega manual do seu jardim quanto a lavagem de pisos, carros e outros. De fácil utilização.',
  'esguicho pistola 6 jatos':
    'Pistola que facilita tanto a rega do seu jardim, a lavagem de pisos e carros. Tem 6 tipos de jato - um para cada serviço',
  'regador plástico com bico 5L':
    'Prático e resistente para auxiliar na rega de jardins, plantas, vasos e outros. Usado também para a lavagem de ambientes',
  'regador plástico com bico 13L':
    'Prático e resistente para auxiliar na rega de jardins, plantas, vasos e outros. Usado também para a lavagem de ambientes',
  'mangueira santeno irrigação':
    'Mangueira micro perfurada ao longo de todo seu comprimento - facilidade na irrigação de áreas contínuas, como gramados.',
  'manguei santeno irrigação 100m':
    'Mangueira micro perfurada ao longo de todo seu comprimento - facilidade na irrigação de áreas contínuas, como gramados.',
  'gotejador para garrafa pet':
    'Gotejador para adaptar em qualquer garrafa pet. Você coloca no vaso ou planta, e ele cuida da irrigação.',
  'pulveriza compressão prévia 2L':
    'Pulverizador que facilita o trabalho: primeiro aciona o embolo e enche o reservatório de ar, e depois aperta o gatilho.',
  'pulverizdor lateral 5L':
    'Pulverizador que facilita o trabalho: primeiro aciona o embolo e enche o reservatório de ar, e depois aperta o gatilho.',
  'pulverizador costal 20L':
    'Pulverizador profissional de ótima qualidade. Você movimenta o embolo ao mesmo tempo que aperta o gatilho.',
  'pulverizador Para Garrafa Pet':
    'Pulverizador para adaptar em qualquer garrafa pet, enroscando em sua boca. Muito prático, e fácil de usar.',
  'tesoura de poda forjada':
    'Tesoura toda em ferro forjado, o que lhe confere muita resistência e durabilidade, com um corte sempre afiado e preciso.',
  'tesourão de poda':
    'Tesoura resistente com cabo longo, que facilita a poda de galhos de maior diâmetro, com um corte sempre afiado e preciso',
  'tesoura cerca viva / grama':
    'Tesoura grande, que facilita o corte de gramados, bem com a poda de cercas vivas, com um corte sempre afiado e preciso.',
  'serrote pode poda master 12"':
    'Serrote própria para a poda de galhos. Ele tem uma curvatura, o que ajuda muito no serviço.',
  'sacho enchadinha coração cabo':
    'A famosa enxadinha, utilizada para abrir pequenas covas, afofar a terra, arrancar matos, fazer recortes e muito mais.',
  'pazinha larga metálica cabo':
    'Ferramenta utilizada no jardim externo, e também no tratamento de vasos, para manuseio de terra e substrato.',
  'arrancador inço metálico cabo':
    'Ferramenta indispensável para o arranquio de ervas daninhas. Facilita a retirada pela raiz, o que evita rebrota do mato.',
  'vassoura rastelo 22 dente cabo':
    'Conhecido também como rastelo, é usado para juntar aparas de grama cortada, bem como folhas caídas.',
  'tela sombrite 30% 3m largura':
    'Tela de sombreamento para cobertura de plantas, áreas de lazer, estacionamentos, etc Diminui em 30% a incidência de sol.',
  'tela sombrite 50% 3m largura':
    'Tela de sombreamento para cobertura de plantas, áreas de lazer, estacionamentos, etc Diminui em 50% a incidência de sol.',
  'limitador separador grama 10cm':
    'Cinta plástica utilizada para delimitar áreas gramadas, evitando que a mesma invada canteiros de plantas e outras áreas.',
  'granitina branca n.º 2':
    'Pedra decorativa usada em jardins, mini jardins, vasos, aquários e outros, melhorando a estética dos mesmos.',
  'granitina palha n.º 00':
    'Pedra decorativa usada em jardins, mini jardins, vasos, aquários e outros, melhorando a estética dos mesmos.',
  'mini seixo rolado n.º 1':
    'Pedra decorativa usada em jardins, mini jardins, vasos, aquários e outros, melhorando a estética dos mesmos.',
  'seixo de mármore n.º 1':
    'Pedra decorativa usada em jardins, mini jardins, vasos, aquários e outros, melhorando a estética dos mesmos.',
  'seixo de rio':
    'Pedra decorativa usada em jardins, mini jardins, vasos, aquários e outros, melhorando a estética dos mesmos.',
  'casca de pinus polida P 40L':
    'Utilizada para a decoração de jardins e vasos, cobrindo a terra. Além de estética, ajuda a manter a umidade do solo.',
  'casca de pinus natural':
    'Utilizada para a decoração de jardins e vasos, cobrindo a terra. Além de estética, ajuda a manter a umidade do solo.',
  'talco enraizador 3000ppm AIB':
    'Para indução e aumento do enraizamento em processos de clonagem vegetal como estaquia, alporquia e cultura de tecidos.',
  'talco enraizador 6000 ppm AIB':
    'Para indução e aumento do enraizamento em processos de clonagem vegetal como estaquia, alporquia e cultura de tecidos.',
  'ácido indolbutírico AIB 1g':
    'Para indução e aumento do enraizamento em processos de clonagem vegetal como estaquia, alporquia e cultura de tecidos.',
  'manta drenagem bidim 1,08m':
    'Utilizada para separar a terra do elemento drenante, evitando que o mesmo seja contaminado com terra.',
  'argila expandid cinasita 1506':
    'Elemento drenante utilizado em vasos e sistemas de drenagem de grandes áreas, bem como elemento decorativo em jardins.',
  'argila expandid cinasita 2215':
    'Elemento drenante utilizado em vasos e sistemas de drenagem de grandes áreas, bem como elemento decorativo em jardins.',
  'argila expandid cinasita 3222':
    'Elemento drenante utilizado em vasos e sistemas de drenagem de grandes áreas, bem como elemento decorativo em jardins.',
  'suporte parede A comum':
    'Suporte de ferro dourado para fixar na parede, e pendurar seus vasos de planta.',
  'suporte parede artístico nº 02':
    'Suporte de ferro dourado para fixar na parede, e pendurar seus vasos de planta.',
  'sup par violeta escada 3 lugar':
    'Suporte de ferro dourado para fixar na parede, e pendurar seus vasos de planta.',
  'sup violeta vertical 3 lugar':
    'Suporte de ferro dourado para fixar na parede, e pendurar seus vasos de planta.',
  'suporte margarida de mesa nº01':
    'Suporte de ferro dourado, com formato da flor da margaria, para apoiar vasos, mantendo-os afastados da superfície.',
  'suporte violeta mesa 3 vasos':
    'Suporte de ferro dourado, em forma de arco. Apoia 3 vasos tamanho 11, tipo os de violeta, fazendo um bonito arranjo.',
  'suporte de mesa n° 03':
    'Suporte de ferro dourado, com formato redondo, para apoiar vasos, mantendo-os afastados da superfície.',
  'suporte piso 3 rds pino 18 cm':
    'Suporte para manter seus vasos afastados do chão, com a comodidade de ter rodas, para facilitar mudá-los de local.',
  'suporte piso 3 rds pino 24 cm':
    'Suporte para manter seus vasos afastados do chão, com a comodidade de ter rodas, para facilitar mudá-los de local.',
  'suporte piso 4 rds pino 31 cm':
    'Suporte para manter seus vasos afastados do chão, com a comodidade de ter rodas, para facilitar mudá-los de local.',
  'suporte piso chapa nº 01 18 cm':
    'Suporte para manter seus vasos afastados do chão, evitando que manchem o mesmo, e facilitando a limpeza por baixo.',
  'suporte piso aro nº 02 21 cm':
    'Suporte para manter seus vasos afastados do chão, evitando que manchem o mesmo, e facilitando a limpeza por baixo.',
  'suporte piso aro nº 05 31 cm':
    'Suporte para manter seus vasos afastados do chão, evitando que manchem o mesmo, e facilitando a limpeza por baixo.',
  'corrente simples 34 cm':
    'Corrente dourada resistente, para pendurar suas plantas. Pode fixar no prato ou no vaso, e pendurar aonde você quiser.',
  'corrente simples 84 cm':
    'Corrente dourada resistente, para pendurar suas plantas. Pode fixar no prato ou no vaso, e pendurar aonde você quiser.',
  'corrente violeta 3 lugares':
    'Corrente dourada resistente, para pendurar suas plantas. Pode fixar no prato ou no vaso, e pendurar aonde você quiser.',
  'arame orquídea encap. 3 pernas':
    'Arame resistente, encapado com plástico verde, para fixar nos seus vasos de orquídeas e pendurá-los.',
  'arame vaso orquídea 3 pernas':
    'Arame resistente, para fixar nos seus vasos de orquídeas e pendurá-los.',
  'arame vaso orquídea 4 pernas':
    'Arame resistente, para fixar nos seus vasos de orquídeas e pendurá-los.',
  'cabo aço p/ vaso 3 pontas 45cm':
    'Cabo reforçado para pendurar suas plantas. Pode ser fixado no prato ou no vaso, e pendurado aonde você quiser.',
  'cabo aço p/ vaso 4 pontas 55cm':
    'Cabo reforçado para pendurar suas plantas. Pode ser fixado no prato ou no vaso, e pendurado aonde você quiser.',
};

function resolverImagemGerada(nome: string): string | undefined {
  const imagemFotosTiradas = imagemPorNomeFotosTiradas[nome];
  if (imagemFotosTiradas) {
    return imagemFotosTiradas;
  }
  const imagemSemente = imagemPorNomeSementes[nome];
  if (imagemSemente) {
    return imagemSemente;
  }
  const imagemNovasFotos = imagemPorNomeNovasFotos[nome];
  if (imagemNovasFotos) {
    return imagemNovasFotos;
  }
  const imagemVasosArames = imagemPorNomeVasosArames[nome];
  if (imagemVasosArames) {
    return imagemVasosArames;
  }
  const arquivo = imagemPorNome[nome];
  if (arquivo && imagensGeradas.has(arquivo)) {
    return `/assets/images/products/generated/${arquivo}`;
  }
  return imagemPadrao;
}

const produtosData: ProdutosData = {
  departamentos: Object.entries(rawProdutosData).map(([departamento, subdepartamentos]) => {
    const produtoPorNome = new Map<
      string,
      { produto: string; variacoes: string[]; imagem?: string; descricao?: string }
    >();
    const produtosPorSubdepartamento = new Map<
      string,
      { produto: string; variacoes: string[]; imagem?: string; descricao?: string }[]
    >();

    Object.entries(subdepartamentos).forEach(([subdepartamento, produtos]) => {
      const listaProdutos: {
        produto: string;
        variacoes: string[];
        imagem?: string;
        descricao?: string;
      }[] = [];

      produtos.forEach((produto) => {
        const existente = produtoPorNome.get(produto.nome);
        if (existente) {
          const complemento = `Também disponível no subdepartamento ${subdepartamento}.`;
          if (!existente.descricao?.includes(complemento)) {
            existente.descricao = existente.descricao
              ? `${existente.descricao} ${complemento}`
              : complemento;
          }
          return;
        }

        const novoProduto = {
          produto: produto.nome,
          variacoes: produto.variacoes,
          imagem: resolverImagemGerada(produto.nome),
          descricao: descricaoPorNome[produto.nome],
        };
        produtoPorNome.set(produto.nome, novoProduto);
        listaProdutos.push(novoProduto);
      });

      produtosPorSubdepartamento.set(subdepartamento, listaProdutos);
    });

    return {
      departamento,
      subdepartamentos: Array.from(produtosPorSubdepartamento.entries()).map(
        ([subdepartamento, produtos]) => ({
          subdepartamento,
          produtos,
        })
      ),
    };
  }),
  observacao: 'Dados normalizados; produtos duplicados anotados por subdepartamento.',
};

export default produtosData;
